import React from "react";
import "../styles/header.css";

function Header(){
    return(
        <div className="header">
            <h1>This is a Calorie App</h1>
        </div>
    )
}




export default Header;
